import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/**
 * Settings → Easeedesk → Change history.
 *
 * Perechea veche: `settings/easeedesk/settings_change_history`.
 *
 * FILTRELE SE TRIMIT LA SERVER, nu se ascund randuri in pagina - jurnalul
 * creste, iar peste cateva mii de randuri o filtrare in browser ar cere aduse
 * toate. La fel si paginarea.
 *
 * `apiGet` pune EL `/api/v2` in fata caii.
 */

export interface HistoryFilters {
  /** 0 = orice tip. */
  ticket_type: number
  /** Sirul gol = orice fel de setare. */
  entity_type: string
  /** 0 = oricine. */
  user_id: number
}

export interface HistoryRow {
  ID: number
  created_at: string
  user_id: number
  /** Gol cand omul nu mai e in `angajati`; ecranul scrie atunci `user #id`. */
  user_name: string
  /** Gol cand setarea e comuna, nu a unui tip anume. */
  type_name: string
  action_label: string
  entity_label: string
  /** `null` cand randul nu tine de un camp anume. */
  field_label: string | null
  old_label: string | null
  new_label: string | null
  /** Cod de culoare, cand valoarea CHIAR e o culoare. */
  old_color: string | null
  new_color: string | null
  /** Cuvantul dinaintea valorii: `from`, `to`, `added`, `cleared, was`, sau gol. */
  old_word: string
  new_word: string
}

export interface HistoryPage {
  title: string
  moduleUrl: string
  rows: HistoryRow[]
  total: number
  page: number
  per_page: number
  filters: HistoryFilters
  types: { ID: number; type_name: string }[]
  entity_types: string[]
  people: { user_id: number; user_name: string }[]
  /** `false` cand jurnalul e gol de tot - altceva decat filtre fara raspuns. */
  available: boolean
}

export function settingsChangeHistoryQuery(filters: HistoryFilters, page: number) {
  const query = new URLSearchParams({
    ticket_type: String(filters.ticket_type),
    entity_type: filters.entity_type,
    user_id: String(filters.user_id),
    page: String(page),
  })

  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'settings_change_history', filters, page],
    queryFn: () => apiGet<HistoryPage>(`/settings/easeedesk/settings_change_history?${query.toString()}`),
  })
}
